<!-- 表單字段渲染器主容器 -->
<div [class]="getFieldCssClass()" [attr.data-field-name]="field.name" [attr.data-field-type]="field.type">

  <!-- 顯示模式和列表模式：純顯示 -->
  <ng-container *ngIf="isDisplayMode()">
    <div class="field-display" [ngSwitch]="field.type">

      <!-- 文字輸入顯示 -->
      <div *ngSwitchCase="'text-input'" class="display-value">
        <label class="display-label">{{ field.label }}</label>
        <span class="display-content">{{ getDisplayValue() }}</span>
      </div>

      <!-- 數字輸入顯示 -->
      <div *ngSwitchCase="'number-input'" class="display-value">
        <label class="display-label">{{ field.label }}</label>
        <span class="display-content">{{ getDisplayValue() }}</span>
      </div>

      <!-- 文字區域顯示 -->
      <div *ngSwitchCase="'textarea'" class="display-value">
        <label class="display-label">{{ field.label }}</label>
        <div class="display-content textarea-content">{{ getDisplayValue() }}</div>
      </div>

      <!-- 下拉選單顯示 -->
      <div *ngSwitchCase="'select'" class="display-value">
        <label class="display-label">{{ field.label }}</label>
        <span class="display-content">{{ getDisplayValue() }}</span>
      </div>

      <!-- 單選按鈕顯示 -->
      <div *ngSwitchCase="'radiobutton'" class="display-value">
        <label class="display-label">{{ field.label }}</label>
        <span class="display-content">{{ getDisplayValue() }}</span>
      </div>

      <!-- 多選核取方塊顯示 -->
      <div *ngSwitchCase="'multi-checkbox'" class="display-value">
        <label class="display-label">{{ field.label }}</label>
        <span class="display-content">{{ getDisplayValue() }}</span>
      </div>

      <!-- 日期時間顯示 -->
      <div *ngSwitchCase="'datetime'" class="display-value">
        <label class="display-label">{{ field.label }}</label>
        <span class="display-content">{{ getDisplayValue() }}</span>
      </div>

      <!-- 日期顯示 -->
      <div *ngSwitchCase="'date'" class="display-value">
        <label class="display-label">{{ field.label }}</label>
        <span class="display-content">{{ getDisplayValue() }}</span>
      </div>

      <!-- 照片上傳顯示 -->
      <div *ngSwitchCase="'photo-upload'" class="display-value">
        <label class="display-label">{{ field.label }}</label>
        <div class="display-content photo-display">
          <ng-container *ngIf="value && value.length > 0; else noPhotos">
            <div class="photo-grid" [class.list-mode]="isListMode()">
              <div *ngFor="let photo of value" class="photo-item">
                <img [src]="photo.url || photo" [alt]="field.label" class="photo-thumbnail" />
              </div>
            </div>
          </ng-container>
          <ng-template #noPhotos>
            <span class="no-content">{{ 'form.display.no_photos' | translate }}</span>
          </ng-template>
        </div>
      </div>

      <!-- 簽名顯示 -->
      <div *ngSwitchCase="'signature'" class="display-value">
        <label class="display-label">{{ field.label }}</label>
        <div class="display-content signature-display">
          <ng-container *ngIf="value; else noSignature">
            <img [src]="value" [alt]="field.label" class="signature-image" />
          </ng-container>
          <ng-template #noSignature>
            <span class="no-content">{{ 'form.display.no_signature' | translate }}</span>
          </ng-template>
        </div>
      </div>

      <!-- 地點顯示 -->
      <div *ngSwitchCase="'location'" class="display-value">
        <label class="display-label">{{ field.label }}</label>
        <div class="display-content location-display">
          <ng-container *ngIf="value; else noLocation">
            <div class="location-info">
              <div *ngIf="value.address" class="location-address">{{ value.address }}</div>
              <div *ngIf="value.coordinates" class="location-coordinates">
                {{ 'form.location.coordinates' | translate }}: {{ value.coordinates.lat }}, {{ value.coordinates.lng }}
              </div>
            </div>
          </ng-container>
          <ng-template #noLocation>
            <span class="no-content">{{ 'form.display.no_location' | translate }}</span>
          </ng-template>
        </div>
      </div>

      <!-- 通用顯示（未明確處理的類型） -->
      <div *ngSwitchDefault class="display-value">
        <label class="display-label">{{ field.label }}</label>
        <span class="display-content">{{ getDisplayValue() }}</span>
      </div>

    </div>
  </ng-container>

  <!-- 表單模式：可編輯的表單元件 -->
  <ng-container *ngIf="isFormMode()">
    <div class="field-form" [ngSwitch]="field.type">

      <!-- 文字輸入元件 -->
      <app-form-text-input *ngSwitchCase="'text-input'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [placeholder]="field.placeholder || ''"
        [required]="field.required || false"
        [readonly]="readonly"
        [formControl]="internalFormControl">
      </app-form-text-input>

      <!-- 數字輸入元件 -->
      <app-form-number-input *ngSwitchCase="'number-input'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [placeholder]="field.placeholder || ''"
        [required]="field.required || false"
        [formControl]="internalFormControl">
      </app-form-number-input>

      <!-- 文字區域元件 -->
      <app-form-textarea *ngSwitchCase="'textarea'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [placeholder]="field.placeholder || ''"
        [required]="field.required || false"
        [readonly]="readonly"
        [formControl]="internalFormControl">
      </app-form-textarea>

      <!-- 下拉選單元件 -->
      <app-form-select *ngSwitchCase="'select'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [placeholder]="field.placeholder || ''"
        [options]="field.options || []"
        [required]="field.required || false"
        [readonly]="readonly"
        [formControl]="internalFormControl">
      </app-form-select>

      <!-- 單選按鈕元件 -->
      <app-form-radiobutton *ngSwitchCase="'radiobutton'"
        [label]="field.label"
        [placeholder]="field.placeholder || ''"
        [id]="field.id"
        [name]="field.name"
        [options]="field.options || []"
        [conditionalInputs]="field.conditionalInputs || null"
        [questionImageUrl]="field.questionImageUrl"
        [questionImageBlobName]="field.questionImageBlobName"
        [questionImageAltText]="field.questionImageAltText"
        [required]="field.required || false"
        [readonly]="readonly"
        [formControl]="internalFormControl">
      </app-form-radiobutton>

      <!-- 多選核取方塊元件 -->
      <app-form-multi-checkbox *ngSwitchCase="'multi-checkbox'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [options]="field.options"
        [required]="field.required || false"
        [readonly]="readonly"
        [enableWhereCondition]="field.enableWhereCondition || false"
        [whereSourceComponent]="field.whereSourceComponent || ''"
        [whereTargetValue]="field.whereTargetValue || ''"
        [formControl]="internalFormControl">
      </app-form-multi-checkbox>

      <!-- 日期時間元件 -->
      <app-form-datetime *ngSwitchCase="'datetime'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [required]="field.required || false"
        [readonly]="readonly"
        [formControl]="internalFormControl">
      </app-form-datetime>

      <!-- 日期元件 -->
      <app-form-date *ngSwitchCase="'date'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [placeholder]="field.placeholder || ''"
        [required]="field.required || false"
        [readonly]="readonly"
        [formControl]="internalFormControl">
      </app-form-date>

      <!-- 日期範圍元件 -->
      <app-form-date-range *ngSwitchCase="'date-range'"
        [label]="field.label"
        [startLabel]="field.startLabel || ('form.date_range.start_label' | translate)"
        [endLabel]="field.endLabel || ('form.date_range.end_label' | translate)"
        [dateType]="field.dateType || 'date'"
        [required]="field.required || false"
        [readonly]="readonly"
        [allowSameDate]="field.allowSameDate !== false"
        [placeholder]="field.placeholder || ''"
        [formControl]="internalFormControl">
      </app-form-date-range>

      <!-- 照片上傳元件 -->
      <app-form-photo-upload *ngSwitchCase="'photo-upload'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [required]="field.required || false"
        [formControl]="internalFormControl">
      </app-form-photo-upload>

      <!-- 大頭照上傳元件 -->
      <app-form-avatar-upload *ngSwitchCase="'avatar-upload'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [required]="field.required || false"
        [maxFileSize]="field.maxFileSize || 5"
        [acceptedFormats]="field.acceptedFormats || ['.jpg', '.jpeg', '.png', '.gif']"
        displayMode="square"
        [placeholder]="field.placeholder || ('form.dynamic.avatar_upload_placeholder' | translate)"
        [formControl]="internalFormControl">
      </app-form-avatar-upload>

      <!-- 簽名元件 -->
      <app-form-signature *ngSwitchCase="'signature'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [required]="field.required || false"
        [formControl]="internalFormControl">
      </app-form-signature>

      <!-- 地點元件 -->
      <app-form-location *ngSwitchCase="'location'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [placeholder]="field.placeholder || ''"
        [required]="field.required || false"
        [formControl]="internalFormControl">
      </app-form-location>

      <!-- 動態API下拉選單元件 -->
      <app-form-dynamic-api-select *ngSwitchCase="'dynamic-api-select'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [placeholder]="field.placeholder || ''"
        [formId]="field.formId || ''"
        [labelField]="field.labelField || ''"
        [valueField]="field.valueField || ''"
        [enableWhereCondition]="field.enableWhereCondition || false"
        [whereSourceComponent]="field.whereSourceComponent || ''"
        [whereTargetField]="field.whereTargetField || ''"
        [required]="field.required || false"
        [formControl]="internalFormControl">
      </app-form-dynamic-api-select>

      <!-- 時間戳記元件 -->
      <app-form-timestamp *ngSwitchCase="'timestamp'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [format]="field.format || 'datetime'"
        [formControl]="internalFormControl">
      </app-form-timestamp>

      <!-- 部門選擇器元件 -->
      <app-form-department-selector *ngSwitchCase="'department-selector'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [placeholder]="field.placeholder || ('form.dynamic.department_selector_placeholder' | translate)"
        [formControl]="internalFormControl">
      </app-form-department-selector>

      <!-- 人員選擇器元件 -->
      <app-form-personnel-selector *ngSwitchCase="'personnel-selector'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [placeholder]="field.placeholder || ('form.dynamic.personnel_selector_placeholder' | translate)"
        [multiSelect]="field.multiSelect || false"
        [formControl]="internalFormControl">
      </app-form-personnel-selector>

      <!-- Approval Personnel Selector 簽核人員選擇器元件 -->
      <app-form-approval-personnel-selector *ngSwitchCase="'approval-personnel-selector'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [placeholder]="field.placeholder || ('form.builder.select_approval_personnel' | translate)"
        [multiSelect]="field.multiSelect || false"
        [enableMemory]="field['enableMemory'] || true"
        [memoryKey]="field['memoryKey']"
        [formControl]="internalFormControl">
      </app-form-approval-personnel-selector>

      <!-- Tags 標籤元件 -->
      <app-form-tags *ngSwitchCase="'tags'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [placeholder]="field.placeholder || ('form.dynamic.tags_placeholder' | translate)"
        [required]="field.required || false"
        [formControl]="internalFormControl">
      </app-form-tags>

      <!-- 簽核流程選擇元件 -->
      <app-form-approval-flow *ngSwitchCase="'approval-flow'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [placeholder]="field.placeholder || ('form.dynamic.approval_flow_placeholder' | translate)"
        [required]="field.required || false"
        [preview]="preview"
        [approvalFlowId]="field.approvalFlowId"
        [formControl]="internalFormControl"
        [getuserlist]="getuseridlist || false"
        [initiatorInfo]="initiatorInfo">
      </app-form-approval-flow>

      <!-- 檔案顯示元件 -->
      <app-file-display *ngSwitchCase="'file-display'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [required]="field.required || false"
        [preview]="preview"
        [formControl]="internalFormControl">
      </app-file-display>

      <!-- 檔案上傳管理元件 -->
      <app-file-upload-manager *ngSwitchCase="'file-upload-manager'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [required]="field.required || false"
        [preview]="preview"
        [config]="field.fileUploadConfig || {}"
        [formControl]="internalFormControl">
      </app-file-upload-manager>

      <!-- 風險評估矩陣元件 -->
      <app-risk-assessment-matrix *ngSwitchCase="'risk-assessment-matrix'"
        [value]="value"
        [disabled]="readonly || disabled"
        [isFormMode]="true"
        (valueChange)="valueChange.emit($event)">
      </app-risk-assessment-matrix>

      <!-- 會議簽名收集元件 -->
      <app-meeting-signature-collection *ngSwitchCase="'meeting-signature-collection'"
        [formControl]="internalFormControl">
      </app-meeting-signature-collection>

      <!-- 填空元件 -->
      <app-fill-in-field *ngSwitchCase="'fill-in'"
        [label]="field.label"
        [template]="field['template']"
        [rows]="field['rows']"
        [fields]="field['fields']"
        [required]="field.required || false"
        [formControl]="internalFormControl">
      </app-fill-in-field>


      <!-- 自動編號元件 -->
      <app-form-auto-numbering *ngSwitchCase="'auto-numbering'"
        [label]="field.label"
        [id]="field.id"
        [name]="field.name"
        [placeholder]="field.placeholder || ''"
        [config]="field.autoNumbering || { elements: [] }"
        [required]="field.required || false"
        [readonly]="readonly"
        [formControl]="internalFormControl">
      </app-form-auto-numbering>

      <!-- 富文本顯示元件 -->
      <app-form-rich-text-display *ngSwitchCase="'rich-text-display'"
        [content]="field['content'] || value"
        [fontSize]="field['fontSize']"
        [color]="field['color']"
        [lineHeight]="field['lineHeight']"
        [maxWidth]="field['maxWidth']"
        [backgroundColor]="field['backgroundColor']"
        [padding]="field['padding']"
        [borderRadius]="field['borderRadius']">
      </app-form-rich-text-display>

      <!-- 不支援的字段類型 -->
      <div *ngSwitchDefault class="unsupported-field">
        <div class="alert alert-warning">
          <i class="fas fa-exclamation-triangle"></i>
          {{ 'form.renderer.unsupported_field_type' | translate }}: {{ field.type }}
        </div>
      </div>

    </div>
  </ng-container>

  <!-- 字段錯誤顯示 -->
  <div class="field-errors" *ngIf="!isValidField && fieldErrors.length > 0">
    <div class="error-message" *ngFor="let error of fieldErrors">
      <i class="fas fa-exclamation-circle"></i>
      {{ error }}
    </div>
  </div>

</div>
